<template>
  <form>
    <md-card data-tour="advanced_audio_codec_config">
      <md-card-header
        class="md-card-header-icon"
        :class="getClass(headerColor)"
      >
        <div class="card-icon">
          <md-icon>volume_up</md-icon>
        </div>
        <h4 class="title">
          Audio Codecs
        </h4>
        <help-link :link="helpLink.link" title="audio"></help-link>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-25 md-small-size-100">
            <md-switch v-model="opusState" data-tour="channel_opus">
              Opus
            </md-switch>
            <md-field>
              <label>Max Bitrate (kbps)</label>
              <md-input
                :disabled="!opusState"
                v-model="channel.codec.opus.bitrate"
                v-on:blur="validateChannel($v.channel.codec.opus.bitrate)"
                type="number"
                class="full-width"
                data-tour="channel_opus_bitrate"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-25 md-small-size-100">
            <md-switch v-model="pcmaState" data-tour="channel_pcma">
              PCMA
            </md-switch>
          </div>
          <div class="md-layout-item md-size-25 md-small-size-100">
            <md-switch v-model="pcmuState" data-tour="channel_pcmu">
              PCMU
            </md-switch>
          </div>
          <div class="md-layout-item md-size-25 md-small-size-100">
            <md-switch v-model="g722State" data-tour="channel_g722">
              G.722
            </md-switch>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import { HelpLinkTemplate } from "@/fmComponents";
import helpLinks from '../../contextualHelpLinks.js';
import validationRules from '../../validationRules';
export default {
  props: {
    channel: null,
    ogChannel: null,
    headerColor: {
      type: String,
      default: ""
    }
  },
  components: {
    'help-link': HelpLinkTemplate
  },
  data: () => ({
    helpLink: helpLinks.channelConfig.audioCodecs
  }),
  validations () {
    return validationRules;
  },
  computed: {
    opusState: {
      get: function() {
        return !this.channel.codec.opus.disabled;
      },
      set: function(state) {
        this.channel.codec.opus.disabled = !state;
      }
    },
    pcmuState: {
      get: function() {
        return !this.channel.codec.pcmu.disabled;
      },
      set: function(state) {
        this.channel.codec.pcmu.disabled = !state;
      }
    },
    pcmaState: {
      get: function() {
        return !this.channel.codec.pcma.disabled;
      },
      set: function(state) {
        this.channel.codec.pcma.disabled = !state;
      }
    },
    g722State: {
      get: function() {
        return !this.channel.codec.g722.disabled;
      },
      set: function(state) {
        this.channel.codec.g722.disabled = !state;
      }
    },
    validationError: function () {
      return this.$v.channel.codec.$anyError;
    }
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    validateChannel: function(input){
      input.$touch();
      if (input.$error){
        this.$store.commit("pushError", "Positive values are required.");
      }
    }
  },
  watch: {
    validationError(val) {
      this.$emit("validationErrorChanged", this, val);
    }
  }
};
</script>
<style lang="scss" scoped>
@media screen and (min-width: 1117px) {
  h4.title{
    display: inline-flex;
  }
  .contextual-help {
    display: inline-flex;
    float: right;
    margin-top: 21px;
  }
  /deep/ .contextual-help > a {
    padding-top: 2px;
  }
}
</style>